import React from "react";

export const RadioGroup = ({ label, name, options, selected, onToggle }) => (
  <>
    <h4>{label}</h4>
    <div className="radio-group">
      {options.map(({ id, label, value }) => (
        <React.Fragment key={id}>
          <input
            type="radio"
            id={id}
            name={name}
            value={value}
            checked={selected === value}
            onClick={() => onToggle(value)}
          />
          <label htmlFor={id}>{label}</label>
        </React.Fragment>
      ))}
    </div>
  </>
);

export const CheckboxGroup = ({ label, options, selected, onChange }) => (
  <>
    <h4>{label}</h4>
    <div>
      {options.map(({ id, label, value }) => (
        <React.Fragment key={id}>
          <input
            type="checkbox"
            id={id}
            value={value}
            checked={selected.includes(value)}
            onChange={onChange}
          />
          <label htmlFor={id}>{label}</label>
          <br />
        </React.Fragment>
      ))}
    </div>
  </>
);

export const DateRangePicker = ({ label, value, onChange }) => (
  <>
    <h4>{label}</h4>
    <label>Start Date:</label>
    <input
      type="date"
      value={value.start}
      onChange={(e) => onChange("start", e.target.value)}
    />
    <label>End Date:</label>
    <input
      type="date"
      value={value.end}
      onChange={(e) => onChange("end", e.target.value)}
    />
  </>
);

export const NumberRange = ({ label, value, onChange }) => (
  <>
    <h4>{label}</h4>
    <label>Minimum:</label>
    <input
      type="number"
      placeholder="0.000"
      min="0.000"
      value={value.min}
      onChange={(e) => onChange("min", e.target.value)}
    />
    <label>Maximum:</label>
    <input
      type="number"
      placeholder=""
      value={value.max}
      onChange={(e) => onChange("max", e.target.value)}
    />
  </>
);
